/** Server print-command descriptor from GET .../print-commands. */
export type PrintCommand = {
  id: string
  title: string
  fill_layout: boolean
  source: 'layout' | 'code'
  layout_node_id?: string | null
}

/**
 * Picker option shape. Legacy designer/storage sources remain for
 * useDesignerPrint; layout/code map 1:1 from PrintCommand for the new hook.
 */
export type PrintLayoutOption =
  | { source: 'designer'; id: string; name: string; is_default: boolean }
  | { source: 'storage'; id: number; name: string; is_default: boolean }
  | { source: 'layout' | 'code'; id: string; name: string; is_default: boolean }

/** Map a PrintCommand into the picker option shape (PrintLayoutPickerMenu). */
export function printCommandToOption(cmd: PrintCommand): PrintLayoutOption {
  return {
    source: cmd.source,
    id: cmd.id,
    name: cmd.title,
    is_default: false,
  }
}

export type PrintDescriptor =
  | {
      source: 'designer'
      connectionId: string
      tableName: string
      instanceId: string
      layoutNodeId: string
    }
  | {
      source: 'storage'
      connectionId: string
      instanceId: string
      layoutId: number
    }

export interface PrintPreviewSession {
  id: string
  layoutName: string
  recordLabel: string
  html: string
  print: PrintDescriptor
}

export interface LayoutPickMenuState {
  anchorEl: HTMLElement
  record: Record<string, unknown>
  mode: 'print' | 'pdf'
}

export interface EntityMetadataWithPrint {
  table_name?: string
  designer_print_layouts?: Array<{ id: string; name: string; is_default: boolean }>
}
